import { Box, Typography } from '@mui/material';

import SectionTitle from './SectionTitle';

const contents = [
  'Bất kể hoàn cảnh thế nào, với chúng tôi mỗi bệnh nhân đều là một cá nhân, với những nhu cầu và mối quan tâm đặc biệt. Sứ mệnh của chúng tôi là cung cấp dịch vụ và chăm sóc y tế tốt',
  'nhất trong môi trường tâm linh. Sứ mệnh của chúng tôi luôn đặt bạn, bệnh nhân và khách của chúng tôi, lên hàng đầu trong tất cả những gì chúng tôi làm. Trong thời gian ở đây với ',
  'chúng tôi, bạn có thể có những câu hỏi về bệnh viện, về việc bạn ở lại, và về nhiều dịch vụ mà chúng tôi cung cấp cho bệnh nhân và khách hàng.',
  'Hướng dẫn thông tin bệnh nhân này được viết và thiết kế để giúp trả lời những câu hỏi đó. Nếu bạn cần thêm thông tin hoặc hỗ trợ, vui lòng liên hệ với bàn thông tin bệnh nhân của\nchúng tôi theo số 0000-0000',

  'Chúng tôi hiểu rằng nhập viện có thể là thời điểm căng thẳng đối với bệnh nhân và gia đình họ. Hãy yên tâm rằng chúng tôi ở đây để hỗ trợ bạn. Và xin vui lòng cho bất kỳ nhân viên bệnh',
  'viện nào biết làm thế nào chúng tôi có thể giúp bạn ở lại với chúng tôi thoải mái hơn hoặc dễ chịu hơn.',

  'Nếu bạn có khiếu nại về chất lượng chăm sóc, khiếu nại của bạn có thể được gửi trực tuyến qua ___ bằng fax đến Văn phòng Giám sát Chất lượng 0000-0000 hoặc gửi mối quan tâm của',
  'bạn đến Văn phòng Giám sát Chất lượng. Nếu bạn có bất kỳ câu hỏi nào về cách nộp đơn khiếu nại, bạn có thể liên hệ với Văn phòng Giám sát Chất lượng theo số 0000-0000.',
];

const contents2 = [
  'Nhập viện',
  'Hầu hết các bệnh nhân nhập viện đều được nhập viện trước hoặc nhập viện qua Phòng cấp cứu. Nếu bạn có thắc mắc về quá trình nhập viện, hãy gọi cho Văn phòng nhập viện theo số ',
  '0000-0000 Vì lý do an ninh, Văn phòng nhập viện sẽ đóng cửa trước 10h và sau 17h30 mỗi ngày. Trong những giờ này, lối duy nhất vào bệnh viện, là qua khu vực kiểm soát ra vào phòng ',
  'cấp cứu.',
];

const contents3 = [
  'Tính bảo mật của bệnh nhân ',
  `Bạn có thể yêu cầu tình trạng "không có thông tin" khi nhập viện hoặc bất cứ lúc nào trong thời gian lưu trú bằng cách gọi cho Văn phòng nhập viện theo số 0000-0000 "Không có thông `,
  'tin" có nghĩa là, theo luật, chúng tôi không thể xác nhận với người gọi điện và khách thăm rằng bạn đang được điều trị tại bệnh viện như một bệnh nhân nội trú, ngoại trú hoặc phòng cấp ',
  'cứu. Những người gọi điện thoại và khách truy cập hỏi thông tin bệnh nhân sẽ không được đưa số phòng hoặc số điện thoại trực tiếp vào phòng của bạn, nhưng bạn có thể chia sẻ thông ',
  'tin này với bạn bè và gia đình nếu bạn thấy phù hợp. Tương tự như vậy, bạn sẽ không nhận được hoa, thư hoặc các giao hàng khác trừ khi chúng được gửi đến số phòng chính xác của ',
  'bạn. Nếu bạn có thắc mắc, vui lòng gọi điện cho phòng nhập viện theo số 0000-0000',
];

const contents4 = [
  'Sắp xếp phòng',
  'Chúng tôi có sẵn các phòng hạng sang, phòng riêng, phòng bán riêng và phòng chung. Mặc dù chúng tôi không thể đảm bảo một loại phòng cụ thể, nhưng sẽ nỗ lực để đáp ứng yêu cầu ',
  'phòng của bệnh nhân.',
];

const FirstContents = () => {
  return (
    <>
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
                marginBottom: i === 3 || i === 5 || i === 7 ? '20px' : '',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>

      <SectionTitle title="Khi bạn tới" />

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents2.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }

          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents3.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }

          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents4.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }

          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default FirstContents;
